import { render, staticRenderFns } from "./SignupBusiness.vue?vue&type=template&id=6809f861&scoped=true"
import script from "./SignupBusiness.vue?vue&type=script&lang=ts"
export * from "./SignupBusiness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809f861",
  null
  
)

export default component.exports